import React from "react";
import InfoIcon from "../../../../../components/InfoIcon";
import { makeStyles } from "@material-ui/core";
import { useFormState } from "react-final-form";
import clsx from "clsx";

const useStyles = makeStyles(() => ({
  currencyContainer: {
    width: 226,
  },
  currencyLabel: {
    fontSize: 14,
    lineHeight: 1,
    color: "#a1a4ac",
  },
  currency: {
    marginTop: 14,
    fontSize: 16,
    color: "#bcbcbc",
  },
  currencyValue: {
    color: "#494949",
  },
}));

export const ShowCurrency = ({ infoText = "" }) => {
  const classes = useStyles();
  const formData = useFormState();
  const value = formData.values.step3?.currency?.name;

  return (
    <div className={classes.currencyContainer}>
      <div className={classes.currencyLabel}>
        Currency {infoText && <InfoIcon text={infoText} portalMode={false} />}
      </div>
      <p className={clsx(classes.currency, value && classes.currencyValue)}>
        {value ? value : "N/A"}
      </p>
    </div>
  );
};
